var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 26,
    viewBox: "0 0 200 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.8769 13.2741V24.8151L16.0928 12.4103V0.938965L46.8769 13.2741Z",
    fill: "url(#paint0_linear_44_94)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.30129V18.8423L16.093 12.4103V0.938965L0 7.30129Z",
    fill: "url(#paint1_linear_44_94)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.877 13.2741V24.8151L62.9681 18.3831V6.91174L46.877 13.2741Z",
    fill: "url(#paint2_linear_44_94)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0926 15.2312L3.13086 20.4588L16.0926 25.6883L29.0543 20.4588L16.0926 15.2312Z",
    fill: "#072F61"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8768 0L33.915 5.2276L46.8768 10.4571L59.8385 5.2276L46.8768 0Z",
    fill: "#072F61"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M110.291 14.2338V0.0131836H114.954V25.2987H110.291V14.2338Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M141.535 21.5483V25.2987H122.331V0.0131836H126.994V21.5483H141.535Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M163.619 16.2455C162.167 13.0364 160.429 9.19379 158.403 4.71765C156.916 7.95808 155.16 11.8007 153.134 16.2455L151.528 19.7663C150.726 21.5226 149.885 23.3668 149.007 25.2987H144.114C146.128 21.0911 150.182 12.6625 156.278 0.0131836H160.713C163.427 5.6209 167.497 14.0494 172.923 25.2987H167.71C167.083 23.9112 166.252 22.0671 165.217 19.7663",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M197.393 23.4245C195.624 24.679 193.064 25.3063 189.712 25.3063H177.32V0.0131836H189.255C192.363 0.0131836 194.741 0.683728 196.387 2.02481C198.034 3.33454 198.857 5.08711 198.855 7.28253C198.834 8.19284 198.599 9.08541 198.17 9.8888C197.714 10.8034 196.86 11.6113 195.609 12.3125C197.073 12.9222 198.171 13.7001 198.902 14.646C199.634 15.6218 200.02 16.8136 200 18.0332C200 20.3779 199.131 22.175 197.393 23.4245ZM185.687 3.7617H181.983V10.666H189.255C190.962 10.666 192.166 10.331 192.866 9.66111C193.197 9.35029 193.462 8.97491 193.642 8.55807C193.823 8.14123 193.917 7.69177 193.918 7.23737C193.92 6.77589 193.828 6.31884 193.647 5.89429C193.466 5.46974 193.2 5.08662 192.866 4.76846C192.166 4.09729 190.962 3.7617 189.255 3.7617H185.687ZM186.009 14.1887H181.983V21.5484H189.949C191.655 21.5484 192.951 21.2742 193.837 20.726C194.69 20.1464 195.116 19.2319 195.116 17.9824C195.116 16.7329 194.69 15.7882 193.837 15.1484C192.959 14.5086 191.663 14.1887 189.949 14.1887H186.009Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M104.705 7.96938V7.92233C104.705 5.45343 103.806 3.5177 102.008 2.11514C100.211 0.712582 97.6651 0.0119308 94.372 0.0131853H81.5176V25.2987H86.1806V15.9256H94.3664C97.6582 15.9256 100.188 15.2243 101.956 13.8217C103.755 12.4167 104.671 10.4659 104.705 7.96938ZM98.3445 11.2606C97.4299 11.8703 96.1039 12.1752 94.3664 12.1752H86.1806V3.7617H94.3664C96.1039 3.7617 97.4299 4.06655 98.3445 4.67625C99.2891 5.31732 99.7614 6.41502 99.7614 7.96938C99.7614 9.52373 99.2891 10.6208 98.3445 11.2606Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_44_94",
    x1: 50.8682,
    y1: 26.5915,
    x2: -11.6184,
    y2: -17.7303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#1C36E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#5262FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_44_94",
    x1: 1947.9,
    y1: 548.602,
    x2: -1245.31,
    y2: 1354.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#1C36E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#5262FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_44_94",
    x1: 71.1765,
    y1: 13.2138,
    x2: 41.4649,
    y2: 18.0576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#1C36E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#5262FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.78ac80f9bd27b5ec02e6c05424ea70a9.svg";
export { ForwardRef as ReactComponent };